<template lang="pug">
  div
    app-modal-modelo-memorial(
      v-if="visualizarModeloMemorial",
      @closeModal="closeModal"
    )
    el-row.margin-medium-top
      app-label.width(
          label="Memorial Descritivo:",
        )
      div.buttons-memorial
        el-button(
          type="text",
          @click="openModal"
        )
          u Modelo
        el-button.btn(
          @click="calcularLimites"
        ) Calcular Limites
      validation-provider(rules="required", v-slot="{ errors }")
        el-input.input(
          :class="{'erro' : errors.length}",
          type='textarea',
          v-model="memorialDescritivo",
          :rows='10',
          name='memorial',
        )
        span.help.erro {{ errors[0] }}
    app-limites.app-limites(
      :limites="limites",
      @changeLimites="changeLimites"
    )
</template>

<script>
import AppModalModeloMemorial from './AppModalModeloMemorial'
import AppLimites from '@/screens/analise/components/AppLimites'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  components: {
    AppLimites,
    AppLabel,
    AppModalModeloMemorial
  },

  mixins: [
    AppNotificacao
  ],

  computed: {
  },

  props: {
    memorialSalvo: {
      type: String,
      default: ''
    },
    limitesSalvo: {
      type: Array
    }
  },

  data () {
    return {
      visualizarModeloMemorial: false,
      memorialDescritivo: '',
      limites: [],
      limite: {
        marcoInicial: null,
        marcoFinal: null,
        north: null,
        east: null,
        confinante: null,
        distancia: null,
        azimute: null,
        direcao: null
      }
    }
  },

  created () {
    this.memorialDescritivo = this.memorialSalvo
    this.limites = this.limitesSalvo
  },

  methods: {
    openModal () {
      this.visualizarModeloMemorial = true
    },

    closeModal () {
      this.visualizarModeloMemorial = false
    },

    changeLimites (limites) {
      this.$emit('changeLimites', limites)
    },

    calcularLimites () {
      this.limites = []
      if (!this.memorialDescritivo || this.memorialDescritivo.length === 0) {
        this.showNotificacao(this.$messages.TIPO_WARNING, null,
          this.$messages.MEMORIAL_DESCRITIVO_VASIO)
        return
      }
      this.memorialDescritivo = this.memorialDescritivo.replace(/\r?\n|\r/g, ' ')
      const memorialSplitTodas = this.memorialDescritivo.split(/(Todas)\ {0,}/g)// eslint-disable-line
      const memorialSplitPartindoDo = memorialSplitTodas && memorialSplitTodas.length > 0 ? memorialSplitTodas[0].split('Partindo do ') : null
      const limitesArray = memorialSplitPartindoDo && memorialSplitPartindoDo.length >= 2 ? memorialSplitPartindoDo[1].split('marco') : null

      if (memorialSplitTodas && memorialSplitTodas.length > 0 &&
          memorialSplitPartindoDo && memorialSplitPartindoDo.length >= 2 &&
          limitesArray.length > 1) {
        limitesArray.pop(limitesArray.length - 1)
        limitesArray.map((limite) => {
          try {
            const marcos = limite.match(/^.*?(?=,)/g)
            const north = limite.match(/(\ N\ {0,})(\=\ {0,})((\d{1,3})((\.\d{3})*)\,\d{0,4}\m)/g); // eslint-disable-line
            const east = limite.match(/(\ E\ {0,})(\=\ {0,})((\d{1,3})((\.\d{3})*)\,\d{0,4}\m)/g); // eslint-disable-line
            const confinante = limite.match(/(por|confrontando com|pela)\ (([\wáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]|\ |-)+)/g); // eslint-disable-line
            const distancia = limite.match(/(distância|distâncias|m\;)\ (([\d,.]|\ )+)/g); // eslint-disable-line
            const azimute = limite.match(/(\d{1,3}\xb0\d{2}\'\d{2}\")/g); // eslint-disable-line
            const regexConfinante = /(pela|por|confrontando com( o lote ocupado por| a| o|\ ))(?<nome>([\wáàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ]| |-)+)/mg // eslint-disable-line
            const confinanteGroup = regexConfinante.exec(confinante)
            if (marcos && north && east) {
              this.limites.push({
                marcoInicial: marcos[0],
                marcoFinal: '',
                north: north[0].match(/((\d{1,3})((.\d{3})),\d{0,4}m)/g)[0],
                east: east[0].match(/((\d{1,3})((.\d{3})),\d{0,4}m)/g)[0],
                confinante: confinanteGroup ? confinanteGroup.groups.nome : this.limites.length > 0 ? this.limites[this.limites.length - 1].confinante : null,
                distancia: distancia[distancia.length - 1].match(/[\d,.]/g).join(''),
                azimute: azimute[0]
              })
            }
          } catch (e) {
            this.showNotificacao(
              this.$messages.TIPO_WARNING,
              this.$messages.TITULO_WARNING,
              this.$messages.LIMITES_INCORRETOS
            )
          }
        })
        for (var i = 0; i < this.limites.length; i++) {
          this.limites[i].marcoFinal = (i === this.limites.length - 1) ? this.limites[0].marcoInicial : this.limites[i + 1].marcoInicial
        }
        this.$emit('changeMemorial', this.memorialDescritivo)
        this.$emit('changeLimites', this.limites)
      } else {
        this.showNotificacao(
          this.$messages.TIPO_WARNING,
          this.$messages.TITULO_WARNING,
          this.$messages.LIMITES_INCORRETOS
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">

.buttons-memorial {
  display: flex;
  justify-content: space-between;
}
.btn {
  padding: 8px;
  margin-top: 1vh;
  margin-bottom: 1vh
}

.margin-medium-top {
  margin-top: 20px;
}

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/components/AppMemorialDescritivo.vue